import React, { FC, CSSProperties } from 'react'

import cn from 'classnames'
import { WrappedFieldProps } from 'redux-form'

import { FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core'

import { useCheckboxFieldStyles } from './styles'

type CheckboxFieldProps = {
  label: string
  isSquare?: boolean
  styles?: CSSProperties
  fullWidth?: boolean
  checkboxComponent?: React.ReactNode
}

const CheckboxField: FC<CheckboxFieldProps & WrappedFieldProps> = ({
  input: { value, ...input },
  meta: { touched, error },
  label,
  isSquare,
  styles,
  fullWidth,
  checkboxComponent: Component = Checkbox,
  ...rest
}) => {
  const cx = useCheckboxFieldStyles()
  const errorMessage = touched && error

  return (
    <>
      <FormControlLabel
        classes={{
          root: cn(cx.root, {
            [cx.label]: isSquare,
            fullWidth
          }),
          label: isSquare && cx.text
        }}
        className={cn({
          checked: !!value && isSquare
        })}
        style={styles}
        label={label}
        control={
          // @ts-ignore
          <Component
            color="primary"
            checked={!!value}
            className={cn(cx.checkbox, { isSquare })}
            {...input}
            {...rest}
          />
        }
      />

      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </>
  )
}

export default CheckboxField
